__turbopack_context__.v({
  "block": "my-sheets-module__Ne1hyG__block",
  "empty": "my-sheets-module__Ne1hyG__empty",
  "header": "my-sheets-module__Ne1hyG__header",
  "list": "my-sheets-module__Ne1hyG__list",
  "name": "my-sheets-module__Ne1hyG__name",
  "sheet": "my-sheets-module__Ne1hyG__sheet",
  "title": "my-sheets-module__Ne1hyG__title",
});
